import { render, staticRenderFns } from "./PostRelatedItems.vue?vue&type=template&id=5694d1a5&"
import script from "./PostRelatedItems.vue.ts?vue&type=script&lang=js&"
export * from "./PostRelatedItems.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports